<template>
  <v-card color="transparent" flat>
    <v-img
      :lazy-src="image.lazySrc"
      :src="image.src"
      max-height="500"
      data-aos="fade"
    >
    </v-img>
    <v-container fluid class="bienvenue">
      <v-container class="welcome py-2">
        <p class="text-center uppercase">
          Every meal is an opportunity to bring energy into your body,
          <br/>
          every mouthful a chance to find happiness.
        </p>
        <h3 class="bienvenue-header">Bienvenue!</h3>
        <p class="text-center">
          {{summary}}
        </p>
        <p class="text-center">
          {{description}}
        </p>
        <v-btn
          color="primary"
          :to="{name: 'services'}"
        >Find out more</v-btn>
      </v-container>
    </v-container>
    <testimonials></testimonials>
    <subscribe-form></subscribe-form>
  </v-card>
</template>

<script>
import {
  VBtn,
  VCard,
  VContainer,
  VImg,
} from 'vuetify/lib'
import MetaInfoBuilder from '@/utils/social'
import SubscribeForm from '@/components/SubscribeForm'
import Testimonials from '@/components/Testimonials'

export default {
  components: {
    SubscribeForm,
    Testimonials,
    VBtn,
    VCard,
    VContainer,
    VImg,
  },
  data: () => ({
    description: `
        Focused on vibrant and sustainable nutrient-rich food, Hertford-based Stéphanie
        specialises in wholesome and healing plant-based cooking. Stéphanie believes in
        cooking with intentional kindness: be kind to the body by putting nourishment
        first, be kind to all life through ethical cooking practices, and be kind to our
        planet through prioritising sustainability.
    `,
    image: require('@/assets/images/home-banner-basket.jpg?vuetify-preload'),
    summary: `
        Reconnect with food. Experience the joy of eating and learning to prepare flavourful
        meals that positively impact your health.
    `,
  }),
  metaInfo() {
    return new MetaInfoBuilder()
        .description(`${this.summary}${this.description}`)
        .image(`${window.location.origin}${this.image.src}`)
        .title('CHEF NATURELLE')
        .build()
  }
}
</script>

<style lang="scss">
.bienvenue-header {
  color: rgba(0, 0, 0, 0.87);
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 50px !important;
  text-transform: none !important;
}

.welcome {
  position: relative;

  p {
    font-size: 20px;
    text-align: center;
  }
}

.bienvenue {
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  font-weight: normal;
  position: relative;
  text-align: center;
}

.uppercase {
  text-transform: uppercase;
}

.v-image.home h3 {
  padding-bottom: 20px;
  font-size: 23px;
  font-weight: bold;
  line-height: 25px;
  text-align: center;
  text-shadow: 0 0 5px black;
}

.v-parallax h3 {
  font-size: 27px;
  line-height: 70px;
  text-align: center;
  text-shadow: 0 0 5px black;
}
</style>
